import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class OfferManager {
	public selectedOfferIdSubj: BehaviorSubject<string> = new BehaviorSubject('');
	public selectedBrandIdSubj: BehaviorSubject<string> = new BehaviorSubject('');
	public selectedBannerIdSubj: BehaviorSubject<string> = new BehaviorSubject('');
	public selectedOfferId: string = '';
	public selectedBrandId: string = '';
	public eventName = '';

	public selectOffer(id: string, eventName: string = ''): void {
		this.selectedOfferId = id;
		this.selectedOfferIdSubj.next(id);
		this.eventName = eventName;
	}

	public selectBanner(id: string, eventName: string = ''): void {
		this.selectedBannerIdSubj.next(id);
		this.eventName = eventName;
	}

	public selectBrand(id: string, eventName: string = ''): void {
		this.selectedBrandId = id;
		this.selectedBrandIdSubj.next(id);
		this.eventName = eventName;
	}
}